
export default  {
  bigAvatar: process.env.REACT_APP_IMAGE_HOST + '/assets/images/avatars/300_300/',
  smallAvatar: process.env.REACT_APP_IMAGE_HOST + '/assets/images/avatars/100_100/',
}
